import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AuthLayout from "./AuthLayout";
import { registerBuyer } from "../../api/auth";

// Mirrors ordr-flutter SignUpRequest fields exactly.
export default function Signup() {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	const formik = useFormik({
		initialValues: {
			firstName: "",
			lastName: "",
			email: "",
			mobileNumber: "",
			password: "",
			confirmPassword: "",
			inviteCode: "",
		},
		validationSchema: yup.object({
			firstName: yup.string().required("Required"),
			lastName: yup.string().required("Required"),
			email: yup.string().email("Enter a valid email").required("Required"),
			mobileNumber: yup
				.string()
				.matches(/^\d{10}$/, "Enter a 10-digit phone number")
				.required("Required"),
			password: yup.string().min(8, "At least 8 characters").required("Required"),
			confirmPassword: yup
				.string()
				.oneOf([yup.ref("password")], "Passwords must match")
				.required("Required"),
		}),
		onSubmit: async (values) => {
			setLoading(true);
			const res = await registerBuyer({
				firstName: values.firstName,
				lastName: values.lastName,
				email: values.email.toLowerCase(),
				countryCode: "+1",
				mobileNumber: values.mobileNumber,
				password: values.password,
				confirmPassword: values.confirmPassword,
				inviteCode: values.inviteCode || undefined,
			});
			setLoading(false);
			if (res && !res.error) {
				toast.success("Account created. Please verify your mobile number.");
				navigate("/verify-otp", { state: { email: values.email.toLowerCase(), mobileNumber: values.mobileNumber, purpose: "signup" } });
			} else {
				toast.error(res?.msg || "Sign up failed");
			}
		},
	});

	return (
		<AuthLayout heading="Create your account" subheading="Set up a buyer account for your company">
			<form onSubmit={formik.handleSubmit}>
				<div className="row g-2 mb-2">
					<div className="col-6">
						<label className="form-label">First name</label>
						<input className="form-control" name="firstName" value={formik.values.firstName} onChange={formik.handleChange} />
						{formik.touched.firstName && formik.errors.firstName ? <div className="text-danger small">{formik.errors.firstName}</div> : null}
					</div>
					<div className="col-6">
						<label className="form-label">Last name</label>
						<input className="form-control" name="lastName" value={formik.values.lastName} onChange={formik.handleChange} />
						{formik.touched.lastName && formik.errors.lastName ? <div className="text-danger small">{formik.errors.lastName}</div> : null}
					</div>
				</div>
				<div className="mb-2">
					<label className="form-label">Email</label>
					<input className="form-control" name="email" value={formik.values.email} onChange={formik.handleChange} />
					{formik.touched.email && formik.errors.email ? <div className="text-danger small">{formik.errors.email}</div> : null}
				</div>
				<div className="mb-2">
					<label className="form-label">Mobile number</label>
					<div className="input-group">
						<span className="input-group-text">+1</span>
						<input className="form-control" name="mobileNumber" value={formik.values.mobileNumber} onChange={formik.handleChange} placeholder="10-digit number" />
					</div>
					{formik.touched.mobileNumber && formik.errors.mobileNumber ? <div className="text-danger small">{formik.errors.mobileNumber}</div> : null}
				</div>
				<div className="row g-2 mb-2">
					<div className="col-6">
						<label className="form-label">Password</label>
						<input type="password" className="form-control" name="password" value={formik.values.password} onChange={formik.handleChange} />
						{formik.touched.password && formik.errors.password ? <div className="text-danger small">{formik.errors.password}</div> : null}
					</div>
					<div className="col-6">
						<label className="form-label">Confirm password</label>
						<input type="password" className="form-control" name="confirmPassword" value={formik.values.confirmPassword} onChange={formik.handleChange} />
						{formik.touched.confirmPassword && formik.errors.confirmPassword ? <div className="text-danger small">{formik.errors.confirmPassword}</div> : null}
					</div>
				</div>
				<div className="mb-3">
					<label className="form-label">Invite code (optional)</label>
					<input className="form-control" name="inviteCode" value={formik.values.inviteCode} onChange={formik.handleChange} />
				</div>
				<button type="submit" className="btn-accent-solid w-100" disabled={loading}>
					{loading ? "Creating account..." : "Sign Up"}
				</button>
				<div className="text-center mt-4 small">
					Already have an account? <Link to="/login" className="fw-semibold">Log in</Link>
				</div>
			</form>
		</AuthLayout>
	);
}
